import React, { Fragment } from 'react';
import { Image, Button } from 'Components';
import BureauVeritasLogo from 'assets/bv-logo.svg';
import history from 'src/history';
import './NavDesktopLogo.css';

const NavDesktopLogo = () => (
  <Fragment>
    <Button onClick={() => history.push('/')} className="nav-desktop-logo">
      <Image src={BureauVeritasLogo} alt="Bureau Veritas Logo" />
    </Button>
    <hr />
  </Fragment>
);

export default NavDesktopLogo;



// WEBPACK FOOTER //
// ./src/containers/Nav/NavDesktop/NavDesktopLogo/NavDesktopLogo.jsx